if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = ProductForm.usableCart(this.cartElement);
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // <cart-drawer> / <cart-notification> ogesinin custom element olarak yukseltildigini dogrular.
      // Yukseltme basarisiz olduysa (ornegin constructor'da hata firlatildiysa) ogenin
      // getSectionsToRender/renderContents metotlari olmaz; bunu bilmeden cagirmak
      // sepete-ekle akisini sessizce oldurur.
      static usableCart(element) {
        if (!element) return null;
        if (typeof element.getSectionsToRender !== 'function') return null;
        if (typeof element.renderContents !== 'function') return null;
        return element;
      }

      onSubmitHandler(evt) {
        if (!this.submitButton) return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Onceki denemeden kalan hata durumu butonu kalici olarak kilitlemesin.
        this.error = false;
        // Sepet ogesi ilk kurulumda hazir degildiyse her gonderimde yeniden dene.
        if (!this.cart) this.cart = ProductForm.usableCart(this.cartElement || document.querySelector('cart-notification') || document.querySelector('cart-drawer'));

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Sunucu tarafinda ekleme basarili olduktan SONRA arayuzu guncellerken bir hata
        // olursa kullaniciya "eklenemedi" demek yanlis olur; bunu ayirt etmek icin isaretle.
        let addedToCart = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            addedToCart = true;

            if (!this.cart) {
              // Sepet cekmecesi kullanilabilir degil: urun eklendi, sepet sayfasina gonder.
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            if (addedToCart) {
              // Urun sepete girdi, yalnizca cekmece guncellemesi basarisiz oldu.
              // Hata gostermek yerine sepeti tazele.
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              window.location = window.routes?.cart_url || '/cart';
              return;
            }
            this.handleErrorMessage(window.cartStrings?.error || 'Something went wrong. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // aria-disabled yalnizca gercekten "tukendi" mesaji gorunuyorsa uzerinde kalsin.
            // Aksi halde gecici bir hata butonu sayfa yenilenene kadar kalici olarak kilitliyordu:
            // onSubmitHandler'in basindaki aria-disabled kontrolu sonraki tiklamalari da engelliyor.
            const soldOutVisible = !!this.submitButton.querySelector('.sold-out-message:not(.hidden)');
            if (!this.error || !soldOutVisible) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        // Guard: bu metot product-info.js'den varyant degisiminde cagriliyor.
        // Buradaki bir TypeError, butonu devre disi birakilmis halde birakip
        // sepete eklemeyi tamamen kilitler.
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings?.addToCart || this.submitButtonText.textContent;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
